import { useEffect, useState } from "react"
import { useGetFiltrosModelosLazyQuery } from "src/gql/schema"
import { FlexibleTableHeaderColumn } from "src/shared/components/data-display/FlexibleTable/flexible-table-items.interface"
import { HeaderProps } from "./useHeaderProps"

const INITIAL_LIMIT = 12

const useModelosHeader = <T extends string>({ headerValue, valueToDisplay }: HeaderProps<T>): FlexibleTableHeaderColumn => {
    const [fetchFiltros] = useGetFiltrosModelosLazyQuery()
    const [items, setItems] = useState<string[]>([])
    const [startingItems, setStartingItems] = useState<string[]>([])
    const [currentLimit, setCurrentLimit] = useState(INITIAL_LIMIT)
    const [hasMore, setHasMore] = useState(true)
    const [loading, setLoading] = useState(false)
    const [searchValue, setSearchValue] = useState<string | null>(null)

    const resetList = () => {
        setCurrentLimit(INITIAL_LIMIT)
        setItems(startingItems)
        setSearchValue(null)
        setHasMore(startingItems.length === INITIAL_LIMIT)
    }

    useEffect(() => {
        setLoading(true)
        fetchFiltros({ variables: { limit: INITIAL_LIMIT } })
            .then((res) => {
                const data = res.data?.filtros_reportes?.modelo || []
                setItems(data)
                setStartingItems(data)
                setHasMore(data.length === INITIAL_LIMIT)
            })
            .finally(() => setLoading(false))
    }, [])

    return {
        value: headerValue,
        valueToDisplay,
        onLoadMore: () => {
            if (loading || !hasMore) return
            const newLimit = currentLimit + INITIAL_LIMIT
            setLoading(true)
            fetchFiltros({ variables: { limit: newLimit, filter_text: searchValue } })
                .then((res) => {
                    const data = res.data?.filtros_reportes?.modelo || []
                    setItems(data)
                    setCurrentLimit(newLimit)
                    setHasMore(data.length === newLimit)
                })
                .finally(() => setLoading(false))
        },
        onInputFilterSuggestionChange: (v) => {
            if (!v.value) {
                resetList()
                return
            }
            if (v.headerValue === headerValue) {
                setLoading(true)
                fetchFiltros({
                    variables: {
                        limit: INITIAL_LIMIT,
                        filter_text: v.value,
                    },
                })
                    .then((res) => {
                        const data = res.data?.filtros_reportes?.modelo || []
                        setSearchValue(v.value)
                        setItems(data)
                        setCurrentLimit(INITIAL_LIMIT)
                        setHasMore(data.length === INITIAL_LIMIT)
                    })
                    .finally(() => setLoading(false))
            }
        },
        filterMenu: items
            .map((v) => ({ value: v, valueToDisplay: v }))
            .filter((item) => item.value !== ""),
        debounceSearchMSTime: 500,
        filterSuggetions: true,
    }
}

export default useModelosHeader
